//Add and Remove Display classes
let removeClass = function(elementId, cl) {
  let element = document.getElementById(elementId); 
  if (typeof(element) != 'undefined' && element != null){
    element.classList.remove(cl);
  }  
}

let addClass = function(elementId, cl) {
let element = document.getElementById(elementId); 
if (typeof(element) != 'undefined' && element != null){
  element.classList.add(cl);
} 
  
}

/*side-nav Regular header*/
let openSideNavTrigger = document.getElementById("hamburger-mobile-button");
let closeSideNavTrigger =  document.getElementById("close-sidenav-button");

openSideNavTrigger && openSideNavTrigger.addEventListener('click', function(ev) {
  removeClass('hamburger-mobile-button','d-flex');
  addClass('close-sidenav-button','d-flex');
  addClass("wu-mobile-menu-content",'d-inline');
 });

closeSideNavTrigger && closeSideNavTrigger.addEventListener('click', function (ev) {
    addClass('hamburger-mobile-button','d-flex');
    removeClass('close-sidenav-button','d-flex');
    removeClass("wu-mobile-menu-content",'d-inline');
  });
